module.exports = __webpack_public_path__ + "static/fonts/DejaVuSerif-BoldItalic.42a9a4e.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/spreadsheet/kendoui/fonts/DejaVu/DejaVuSerif-BoldItalic.ttf?v=1.1
// module id = 1640
// module chunks = 28